import { Trans } from "@lingui/macro";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@mui/material";
import { MatesSelect } from "@sinossi/mates-react-library";
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { JobType } from "../../../models";

interface MultipleBrandRoleProps extends UseFormReturn {
    brands: { id: string, name: string }[]
    updateRoles: (brand: string) => void
    color: string
}

interface MultipleBrandRoleState {

}

export class MultipleBrandRole extends React.Component<MultipleBrandRoleProps, MultipleBrandRoleState> {
    render() {
        return (
            <Accordion sx={{
                '& .MuiAccordionSummary-root': {
                    flexDirection: 'row-reverse', // Align icon to the left
                    width: "100%"
                }
            }}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}
                    aria-controls={"panel-content-multiple-brand-role"}
                    id={"panel-header-multiple-brand-role"}
                    sx={{
                        backgroundColor: "secondary.main",
                        color: "white",
                        width: "100%",
                        p: 0,
                        m: 0
                    }}
                >
                    <Typography sx={{ pl: "12px" }}>
                        <Trans id={"multiple-brand-role"}>
                            Gestione dei ruoli
                        </Trans>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ py: 1, px: 3 }}>
                    <Grid container spacing={3}>
                        {
                            this.props.brands.map((brand) => (
                                <Grid item xs={12} md={3}>
                                    <MatesSelect
                                        variant={"outlined"}
                                        label={brand.name}
                                        name={`multiple-brand-role.${brand.id}`}
                                        control={this.props.control}
                                        trigger={this.props.trigger}
                                        formState={this.props.formState}
                                    >
                                        {
                                            Object.values(JobType).map((job: any) => (
                                                <option key={job} value={job}>
                                                    <Trans id={`enums.representative-job.${job}`}>
                                                    </Trans>
                                                </option>
                                            ))
                                        }
                                    </MatesSelect>
                                </Grid>
                            ))
                        }
                    </Grid>
                </AccordionDetails>
            </Accordion>
        )
    }
}
